export default "__VITE_ASSET__$Y$TNz52__"